<template>
    <div class="container">
        <div class="group-wrapper">
            <van-cell-group>
                <van-field type="text" v-model="profile.name" placeholder="请输入真实姓名" label="姓名" />
                <van-field readonly clickable name="picker" :value="idType.text" label="证件类型" placeholder="请选择"
                    :is-link="true" @click="showIdTypePicker = true" />
                <van-popup v-model="showIdTypePicker" position="bottom">
                    <van-picker show-toolbar :columns="idTypes" @confirm="onSelectIdType"
                        @cancel="showIdTypePicker = false" />
                </van-popup>
                <van-field type="text" v-model="profile.idcard" placeholder="请填写证件号码" label="证件号码"
                    @blur="autoFillProfile()" />
                <van-field name="radio" label="性别">
                    <template #input>
                        <van-radio-group v-model="profile.gender" direction="horizontal">
                            <van-radio name="1">男</van-radio>
                            <van-radio name="2">女</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field readonly clickable v-model="profile.birthday" placeholder="必填" label="出生日期"
                    @click="showDatePicker=true" />
                <van-popup v-model="showDatePicker" position="bottom">
                    <van-datetime-picker type="date" title="选择出生日期" :min-date="minDate" :max-date="maxDate"
                        :value="currentDate" @confirm="onConfirmDate" @cancel="showDatePicker = false" />
                </van-popup>

                <van-field readonly clickable name="picker" :value="profile.marriage.text" label="婚姻状况"
                    placeholder="请选择" :is-link="true" @click="showMaritalPicker = true" v-if="profile" />
                <van-popup v-model="showMaritalPicker" position="bottom">
                    <van-picker show-toolbar :columns="maritalStatus" @confirm="onSelectMarital"
                        @cancel="showMaritalPicker = false" />
                </van-popup>

                <!-- <van-field type="text" v-model="relationship" placeholder="请选择" label="亲属关系" /> -->
                <van-field readonly clickable name="picker" :value="profile.relationship" label="亲属关系" placeholder="请选择"
                    @click="showRealtionPicker = true" v-if="profile.relationship!='本人'" />
                <van-popup v-model="showRealtionPicker" position="bottom">
                    <van-picker show-toolbar :columns="relations" @confirm="onSelectRealtion"
                        @cancel="showRealtionPicker = false" />
                </van-popup>
            </van-cell-group>
            <van-cell-group style="margin-top:12px">
                <van-field type="text" v-model="profile.mobile" placeholder="用于接收短信服务通知" label="手机号码"
                    :disabled="action !='add'" />
                <van-field v-model="profile.sms_code" center clearable label="验证码" placeholder="请输入短信验证码"
                    v-if="action== 'add'">
                    <template #button>
                        <van-button size="small" type="info" @click="sendCode()" v-if="!isSending">发送验证码
                        </van-button>
                        <van-button size="small" type="info" :disabled="true" v-else>已发送（{{countDown}}）</van-button>
                    </template>
                </van-field>
            </van-cell-group>
        </div>
        <div class="profile-bottom">
            <van-button type="info" size="large" @click="saveProfile()">保存信息</van-button>
            <van-button type="default" size="large" @click="deleteProfile()"
                v-if="action== 'edit' && profile.relationship !='本人'" style="margin-top:24px">取消绑定</van-button>
        </div>

        <div class="captcha-wrap">
            <van-overlay :show="captchaDialogVisible">
                <captcha-dialog v-if="captchaDialogVisible" @change="sendSmsCodeWithCaptcha"
                    @cancel="captchaDialogVisible=false" />
            </van-overlay>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .container {
        padding: 12px;
    }

    .group-wrapper {
        border-radius: 5px;

        .van-cell-group {
            border-radius: 8px;

            .van-field {
                line-height: 30px;
                height: 50px;
            }
        }

        .van-field {
            background-color: transparent;
        }
    }

    .profile-bottom {
        margin-top: 24px;
    }
</style>

<script>
    import {
        mapState,
        mapActions
    } from "vuex";
    import {
        getSex,
        getBirthday,
        checkIdCard,
    } from '@/libs/validate-utils'
    import moment from 'moment';
    import Vue from 'vue';
    import {
        DatetimePicker
    } from 'vant';
    import * as api_user from "@/api/user";
import captchaDialog from './captchaDialog.vue';

    Vue.use(DatetimePicker);
    export default {
  components: { captchaDialog },
        data() {
            return {
                showRealtionPicker: false,
                showIdTypePicker: false,
                showDatePicker: false,
                relations: ['父母', '子女', '兄弟', '姐妹', '其它'],
                showMaritalPicker: false,
                maritalStatus: [{
                        text: '未婚',
                        value: 0
                    },
                    {
                        text: '已婚',
                        value: 1
                    },
                    {
                        text: '其它',
                        value: 2
                    },
                ],
                profile: {
                    id: 0,
                    account_id: 0,
                    name: '',
                    idtype: 0,
                    idcard: '',
                    gender: '',
                    birthday: '',
                    age: '',
                    relationship: '',
                    marriage: {
                        text: '',
                        value: null
                    },
                    mobile: '',
                    sms_code: '',
                    genders: ['男', '女'],
                },
                minDate: new Date(1920, 1, 1),
                maxDate: new Date(2020, 1, 1),
                currentDate: new Date(1980, 1, 1),
                isSending: false,
                countDown: 60,
                timer: undefined,
                idType: {
                    text: '身份证',
                    value: 0
                },
                idTypes: [{
                        text: '身份证',
                        value: 0
                    },
                    {
                        text: '护照',
                        value: 1
                    },
                    {
                        text: '港澳台通行证/居住证',
                        value: 2
                    },
                    {
                        text: '其它证件',
                        value: 3
                    },
                ],
                captchaDialogVisible: false, //显示图片验证码窗口
            }
        },
        props: {
            action: {
                type: String,
                default: function () {
                    return "add"; //add 或者 update
                }
            },
            value: {
                type: Object,
            }
        },
        computed: {
            ...mapState({
                configs: state => state.hospital.configs
            }),
            //是否启用图形验证码
            enableCaptcha() {
                if (this.configs && this.configs.length > 0) {
                    var cfg = this.configs.find(it => it.code == 'enable_captcha');
                    if (cfg && cfg.value == '是')
                        return true;
                }
                return false;
            },
        },
        watch: {
            value: function (newVal, oldVal) {
                this.profile.id = newVal.id;
                this.profile.name = newVal.name;
                this.profile.account_id = newVal.account_id;
                this.profile.gender = newVal.sex.toString();
                this.profile.birthday = moment(newVal.birth).format("YYYY-MM-DD");
                this.profile.idtype = newVal.idtype;
                this.profile.idcard = newVal.idcard;
                this.profile.mobile = newVal.phone;
                this.profile.relationship = newVal.relation;
                if (newVal.marital == 0) {
                    this.profile.marriage = this.maritalStatus[0];
                } else if (newVal.marital == 1) {
                    this.profile.marriage = this.maritalStatus[1];
                } else {
                    this.profile.marriage = this.maritalStatus[2];
                }
                this.idType = this.idTypes[this.profile.idtype];
            }
        },
        methods: {
            onSelectRealtion(value) {
                this.profile.relationship = value;
                this.showRealtionPicker = false;
            },
            onSelectIdType(item) {
                this.idType = item;
                this.showIdTypePicker = false;
            },
            onConfirmDate(date) {
                console.log(date);
                this.profile.birthday = moment(date).format("YYYY-MM-DD");
                this.showDatePicker = false;
            },
            onSelectMarital(item) {
                console.log(item);
                this.profile.marriage = item;
                this.showMaritalPicker = false;
            },
            checkProfile() {
                if (!this.profile) {
                    this.$toast.fail("人员信息无效");
                    return false;
                }
                if (!this.profile.name || this.profile.name == "" || this.profile.name.length > 8) {
                    this.$toast.fail("请填写姓名");
                    return false;
                }
                if (!this.profile.idcard || this.profile.idcard == "" || this.profile.idcard.length > 20) {
                    this.$toast.fail("请填写正确的证件号码");
                    return false;
                }
                if (this.idType && this.idType.value == 0 && checkIdCard(this.profile.idcard) > 0) {
                    this.$toast.fail("身份证号无效，请重新填写")
                    return false;
                }
                if (!this.profile.gender || this.profile.gender == "") {
                    this.$toast.fail("请选择性别");
                    return false;
                }
                if (!this.profile.birthday || this.profile.birthday == "") {
                    this.$toast.fail("请填写出生日期");
                    return false;
                }
                if (!this.profile.relationship || this.profile.relationship == "") {
                    this.$toast.fail("请选择亲属关系");
                    return false;
                }
                if (!this.profile.marriage || this.profile.marriage.value == null) {
                    this.$toast.fail("请选择婚姻状况");
                    return false;
                }

                return true;
            },
            saveProfile() {
                if (!this.checkProfile()) {
                    return;
                }
                //可以修改证件类型
                this.profile.idtype = this.idType.value;
                var loginAccount = api_user.getLoginedUser();
                var user = {
                    id: this.profile.id,
                    account_id: loginAccount.id,
                    name: this.profile.name,
                    sex: parseInt(this.profile.gender),
                    birth: this.profile.birthday.replace('-', '').replace('-', ''),
                    marital: this.profile.marriage.value,
                    idtype: this.profile.idtype,
                    idcard: this.profile.idcard,
                    phone: this.profile.mobile,
                    relation: this.profile.relationship,
                    jlzt: 0,
                    smsCode: this.profile.sms_code,
                };
                console.log(user);
                //判断是新增还是修改
                if (this.action == "add") {
                    if (!user.smsCode || user.smsCode == "") {
                        this.$toast.fail("请输入手机验证码");
                        return;
                    }
                    console.log("新增体检人员");
                    api_user.addProfile(user).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.$toast("保存成功！")
                            this.$router.go(-1);
                        } else {
                            this.$toast.fail(res.msg);
                        }
                    }).catch(err => {
                        this.$toast("保存人员信息出错！")
                    });

                } else if (this.action == "edit") {
                    console.log("修改体检人员");
                    api_user.updateProfile(user).then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.$toast("保存成功！")
                            this.$router.go(-1);
                        } else {
                            this.$toast.fail(re.msg);
                        }
                    }).catch(err => {
                        this.$toast("保存人员信息出错！")
                    });
                }
            },
            deleteProfile() {
                if (!this.value || !this.value.id || this.value.id == 0 || this.value.relation == "本人") {
                    this.$toast.fail("无效操作")
                    return;
                }
                this.$Dialog.confirm({
                        message: '取消绑定后无法再预约或查看亲属报告，是否继续？',
                        "cancelButtonText": "我再想想",
                        "confirmButtonText": "取消绑定",
                    })
                    .then(() => {
                        api_user.deleteProfile(this.value.id).then(res => {
                            console.log(res);
                            if (res.code == 200) {
                                this.$toast("取消绑定成功")
                                this.$router.go(-1);
                            }
                        }).catch(err => {
                            this.$toast("取消绑定人员信息出错！")
                        });
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            autoFillProfile() {
                let idcard = this.profile.idcard;
                if (!this.idType || this.idType.value != 0 || !idcard || idcard.length == 0) {
                    return;
                }
                if (checkIdCard(idcard) > 0) {
                    this.$toast("身份证号无效，请重新填写")
                    return
                }
                let sex = getSex(idcard);
                let birthday = getBirthday(idcard);
                console.log(birthday);
                this.profile.gender = sex;
                this.profile.birthday = moment(birthday).format("YYYY-MM-DD");

            },
            //发送验证码
            sendCode() {
                let hospId = this.$route.query.hospid;
                if (!this.profile || !this.profile.mobile || this.profile.mobile.length != 11) {
                    this.$toast.fail("请填写正确的手机号码");
                    return;
                }
                if (this.enableCaptcha) {
                    this.captchaDialogVisible = true;
                    return;
                }
                let _this = this;
                api_user.sendSmsCode(hospId, this.profile.mobile).then(resp => {
                    if (resp.code != 200) {
                        this.$toast.fail("获取短信验证码出错！");
                    } else {
                        if (process.env.NODE_ENV !== 'production') {
                            _this.sms = resp.data;
                        }
                    }
                })

                this.isSending = true;
                this.countDown = 60;
                if (!this.timer) {
                    let _this = this;
                    this.timer = setInterval(() => {
                        if (_this.countDown <= 0) {
                            _this.isSending = false;
                        } else {
                            _this.countDown--;
                        }
                    }, 1000);
                }
            },
            //发送短信验证码（需要进行图片验证）
            sendSmsCodeWithCaptcha(captcha) {
                let _this = this;
                let hospId = this.$route.query.hospid;
                _this.captchaDialogVisible = false;
                api_user.sendSmsVerificationCode(hospId, this.profile.mobile, captcha.key, captcha.value).then(res => {
                    if (res.code != 200) {
                        _this.$Toast.fail(res.msg, 5000);
                    } else {
                        // 已发送，待用户输入短信码
                        _this.isSending = true;
                        _this.countDown = 90;
                        if (!_this.timer) {
                            _this.timer = setInterval(() => {
                                if (_this.countDown <= 0) {
                                    _this.isSending = false;
                                } else {
                                    _this.countDown--;
                                }
                            }, 1000);
                        }
                    }
                })
            },
        },
    }
</script>